<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import AuthLayout from '@/layouts/AuthLayout.vue'
import RegisterForm from '@/components/auth/RegisterForm.vue'
import { getErrorMessage } from '@/utils/errorHandling'



const authStore = useAuthStore()
const router = useRouter()
const error = ref<string | null>(null)
const successMessage = ref<string | null>(null)

const handleRegister = async (userData: {
  username: string
  email: string
  password: string
  confirmPassword: string // Add this
  first_name: string
  last_name: string
}) => {
  try {
    await authStore.register({
      username: userData.username,
      email: userData.email,
      password: userData.password,
      confirmPassword: userData.confirmPassword, // Include this
      first_name: userData.first_name,
      last_name: userData.last_name,
    })
    successMessage.value = 'Registration successful! Redirecting to login...'
    setTimeout(() => router.push('/login'), 2000)
  } catch (err: unknown) {
    error.value = getErrorMessage(err, 'Registration failed. Please try again.')
    setTimeout(() => (error.value = null), 5000)
  }
}
</script>

<template>
  <AuthLayout>
    <template #header>
      <div class="text-center">
        <h1 class="text-3xl font-bold text-gray-900">Create your account</h1>
        <p class="mt-2 text-gray-600">
          Already have an account?
          <RouterLink
            to="/login"
            class="font-medium text-green-600 hover:text-green-500 transition-colors"
          >
            Sign in here
          </RouterLink>
        </p>
      </div>
    </template>

    <div class="mt-8 max-w-md mx-auto">
      <div
        v-if="error"
        class="mb-4 p-4 rounded-lg bg-red-50 border border-red-200 text-red-600 text-sm"
      >
        {{ error }}
      </div>

      <div
        v-if="successMessage"
        class="mb-4 p-4 rounded-lg bg-green-50 border border-green-200 text-green-600 text-sm"
      >
        {{ successMessage }}
      </div>

      <div class="bg-white p-8 rounded-xl shadow-sm border border-gray-100">
        <RegisterForm @submit="handleRegister" @error="(msg) => (error = msg)" />
      </div>
    </div>
  </AuthLayout>
</template>
